var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "Machining Products",
      "tabActive": "CMP Retainer - Ring",
      "bg": "/images/sub/visual/sv2.png"
    }
  }), _c('section', {
    staticClass: "sub-section sub-section--first"
  }, [_c('v-container', [_c('h2', {
    staticClass: "page-tit mb-lg-42"
  }, [_vm._v(" CMP Retainer - Ring ")])]), _c('sub-bg-image', {
    attrs: {
      "src": "/images/sub/products/cmp/cmp-top-img.png",
      "className": "h-lg-705px"
    }
  }, [_c('h3', {
    staticClass: "tit font-weight-semibold mb-4 mb-lg-16"
  }, [_vm._v(" CMP ")]), _c('p', {
    staticClass: "page-text-lg color-point font-weight-semibold mb-8 mb-md-50 mb-lg-84"
  }, [_vm._v(" Chemical Mechanical Polishing ")]), _c('p', {
    staticClass: "page-text color-grey-51 mb-24 mb-lg-50"
  }, [_vm._v(" One of the eight major processes in semiconductor manufacturing. "), _c('br'), _vm._v(" A semiconductor process that polishes the wafer flat using chemical reaction and mechanical force. ")]), _c('p', {
    staticClass: "color-point font-size-14 font-size-lg-16 line-height-19 font-weight-bold px-10 px-lg-20 border border-color-point mb-6 mb-lg-14",
    staticStyle: {
      "width": "fit-content"
    }
  }, [_vm._v(" Role of Retainer Ring ")]), _c('p', {
    staticClass: "font-size-14 font-size-lg-16 color-grey-51 mb-12 mb-lg-24"
  }, [_vm._v(" It is installed on the CMP equipment HEAD, and serves as a guide to prevent the separation of the wafer during the CMP process and to control the uniformity of the wafer. ")]), _c('p', {
    staticClass: "color-point font-size-14 font-size-lg-16 line-height-19 font-weight-bold px-10 px-lg-20 border border-color-point mb-6 mb-lg-14",
    staticStyle: {
      "width": "fit-content"
    }
  }, [_vm._v(" Type of Retainer Ring ")]), _c('p', {
    staticClass: "font-size-14 font-size-lg-16 color-grey-51 mb-4 mb-lg-16"
  }, [_c('strong', {
    staticClass: "font-weight-bold color-point"
  }, [_vm._v("Two-Body Type")]), _vm._v(" "), _c('br'), _vm._v(" (Metal + Engineering Plastic bonding type) "), _c('br'), _vm._v(" Retainer Ring, which applies bonding technology to metal (SUS 304 or 316) and engineering plastic (PPS, PEEK and Ect..) ")]), _c('p', {
    staticClass: "font-size-14 font-size-lg-16 color-grey-51 mb-4 mb-lg-16"
  }, [_c('strong', {
    staticClass: "font-weight-bold color-point"
  }, [_vm._v("One-Body Type ")]), _vm._v(" "), _c('br'), _vm._v(" (Engineering Plastic material only –PPS, PEEK and Ect..) "), _c('br'), _vm._v(" An integral retainer ring without bonding made of only one engineering plastic material ")]), _c('p', {
    staticClass: "font-size-14 font-size-lg-16 color-grey-51"
  }, [_c('strong', {
    staticClass: "font-weight-bold color-point"
  }, [_vm._v("Insert Over Molding Type")]), _vm._v(" "), _c('br'), _vm._v(" Retainer ring injection-molded with insert embedded inside ")])])], 1), _vm.boards ? _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('slide-primary', _vm._l(_vm.boards, function (board) {
    return _c('div', {
      key: board._id,
      staticClass: "swiper-slide"
    }, [_c('div', {
      staticClass: "pb-16 pb-lg-30 border-bottom"
    }, [_c('div', {
      staticClass: "thum-wrap"
    }, [_c('div', {
      staticClass: "thum",
      style: "background-image: url(".concat(board.thumb, ")")
    })])])]);
  }), 0)], 1)], 1) : _vm._e(), _c('section', {
    staticClass: "sub-section sub-section--last"
  }, [_c('v-container', [_c('inquiry', {
    attrs: {
      "src": "/images/sub/distributor/dupont/dupont-img1.png",
      "name": "Kwang Ho, Lee",
      "tel": "+82-31-765-2268",
      "mail": "khlee@ist-co.kr",
      "fax": "+82-31-765-2389"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }